import React from 'react';
import { Box, Container, Typography, useMediaQuery } from '@mui/material';

// Import images for assets
import CryptoImage from '/Images/cryptocurrency_9156686 2.svg'; // Replace with the correct path
import TokenizedImage from '/Images/Group 1363.svg'; // Replace with the correct path
import CurrencyImage from '/Images/Group 1364.svg'; // Replace with the correct path

const Solution = () => {
  // Check if the screen is mobile-sized
  const isMobile = useMediaQuery('(max-width: 767px)');

  return (
    <section
      style={{ 
        backgroundColor: '#E7E4E2',
        padding: '0rem 0',
        paddingBottom: '3rem',
        position: 'relative',
        fontFamily: "Poppins", 
      }}
    >
      <Container
        style={{ 
          width: '90%', 
          maxWidth: '1260px', 
          backgroundColor: '#E7E4E2',
          paddingTop: '0rem',
          padding: isMobile ? '1rem' : '1.5rem',
          marginTop: '0',
          position: 'relative',
          zIndex: '1',
          fontFamily: "Poppins",
        }}
      >
        {/* Title */}
        <Typography 
          variant="h4" 
          align="center" 
          gutterBottom 
          style={{ 
            fontWeight: 'bold', 
            background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            marginTop: '1rem',
            fontFamily: "Poppins", 

            marginBottom: '2rem',
            fontSize: isMobile ? '30px' : '40px', // Adjust font size for mobile
          }}
        >
          Building Solutions that Matter
        </Typography>

        {/* Card Layout */}
        <Box 
          display="flex" 
          flexDirection={isMobile ? 'column' : 'row'} // Switch to column on mobile
          justifyContent={isMobile ? 'center' : 'space-between'}
          alignItems={isMobile ? 'center' : 'flex-start'}
          gap="1rem"
          flexWrap={isMobile ? 'nowrap' : 'wrap'}
        >
          {/* Card 1 */}
          <Box
            style={{
              flex: isMobile ? '1 1 100%' : '1 1 30%', // Full width on mobile
              padding: '1rem',
              paddingTop: '2rem',
              paddingBottom: '2rem',
              backgroundColor: '#E7E4E2',
              textAlign: 'center',
              marginBottom: isMobile ? '1rem' : '0', // Add spacing between cards on mobile
            }}
          >
            <img 
              src={CryptoImage} 
              alt="Crypto Assets" 
              style={{ width: '4rem', marginBottom: '1rem' }} 
            />
            <Typography 
              variant="h6" 
              style={{ 
                color: '#214D73', 
                fontWeight: 'bold', 
                marginBottom: '0.5rem', 
                fontSize: isMobile ? '18px' : '22px'  // Adjust font size for mobile
              }}
            >
              Crypto Assets
            </Typography>
            <Typography 
              style={{ 
                maxWidth: '280px', 
                margin: '0 auto', 
                fontSize: isMobile ? '0.875rem' : '1rem' // Adjust font size for mobile
              }} 
              variant="body2" 
              color="textSecondary"
            >
              Securely custody and manage the widest range of crypto assets
            </Typography>
          </Box>

          {/* Card 2 */}
          <Box
            style={{
              flex: isMobile ? '1 1 100%' : '1 1 30%', // Full width on mobile
              padding: '1rem',
              paddingTop: '2rem',
              paddingBottom: '2rem',
              backgroundColor: '#E7E4E2',
              textAlign: 'center',
              marginBottom: isMobile ? '1rem' : '0', // Add spacing between cards on mobile
            }}
          >
            <img 
              src={TokenizedImage} 
              alt="Secure Payments" 
              style={{ width: '4rem', marginBottom: '1rem' }} 
            />
            <Typography 
              variant="h6" 
              style={{ 
                color: '#214D73', 
                fontWeight: 'bold', 
                marginBottom: '0.5rem', 
                fontSize: isMobile ? '18px' : '22px'  // Adjust font size for mobile
              }}
            >
              Secure Payments
            </Typography>
            <Typography 
              style={{ 
                maxWidth: '300px', 
                margin: '0 auto', 
                fontSize: isMobile ? '14px' : '16px' // Adjust font size for mobile
              }} 
              variant="body2" 
              color="textSecondary"
            >
              We manage accounts receivable to ensure a secure transaction process.
            </Typography>
          </Box>

          {/* Card 3 */}
          <Box
            style={{
              flex: isMobile ? '1 1 100%' : '1 1 30%', // Full width on mobile
              padding: '1rem',
              paddingTop: '2rem',
              paddingBottom: '2rem',
              backgroundColor: '#E7E4E2',
              textAlign: 'center',
            }}
          >
            <img 
              src={CurrencyImage} 
              alt="Stablecoin" 
              style={{ width: '4rem', marginBottom: '1rem' }} 
            />
            <Typography 
              variant="h6" 
              style={{ 
                color: '#214D73', 
                fontWeight: 'bold', 
                marginBottom: '0.5rem', 
                fontSize: isMobile ? '18px' : '22px'  // Adjust font size for mobile
              }}
            >
              Stablecoin
            </Typography>
            <Typography 
              style={{ 
                maxWidth: '300px', 
                margin: '0 auto', 
                fontSize: isMobile ? '14px' : '16px' // Adjust font size for mobile
              }} 
              variant="body2" 
              color="textSecondary"
            >
              Put your asset transactions in expert hands. Transfer any stablecoin or digital assets.
            </Typography>
          </Box>
        </Box>
      </Container>
    </section>
  );
};

export default Solution;
